<div *ngIf="!creandoProc">
    <p *ngIf="esGmu" class="text-muted mb-3">
        {{ 'PROCEDIMIENTOS.GMU_HINT_DYN' | translate }}
    </p>
    <div class="listado__stats">
        <div class="listado__stat">
            <div class="listado__stat-value">{{ totalProcedimientos }}</div>
            <div class="listado__stat-label">{{ 'COMMON.TOTAL' | translate }}</div>
        </div>
        <div class="listado__stat">
            <div class="listado__stat-value is-success">{{ procedimientosActivos }}</div>
            <div class="listado__stat-label">{{ 'COMMON.ACTIVE' | translate }}</div>
        </div>
        <div class="listado__stat">
            <div class="listado__stat-value is-muted">{{ procedimientosInactivos }}</div>
            <div class="listado__stat-label">{{ 'COMMON.INACTIVE' | translate }}</div>
        </div>
    </div>

    <div class="listado listado--cards-accent">
        <table mat-table [dataSource]="dataSource" matSort class="table align-middle mb-0 bg-white">
            <ng-container matColumnDef="departamento.nombre" class="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by departamento.nombre" class="header">{{ 'PROCEDIMIENTOS.COL_DEPT' | translate }}</th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'PROCEDIMIENTOS.COL_DEPT' | translate">
                    {{ element.departamento.nombre }}
                </td>
            </ng-container>

            <ng-container matColumnDef="nombre">
                <th class="asuntoNombre" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by nombre" class="header">{{ 'PROCEDIMIENTOS.COL_NAME' | translate }}</th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'PROCEDIMIENTOS.COL_NAME' | translate" data-role="title">
                    {{ element.nombre }}
                </td>
            </ng-container>

            <ng-container matColumnDef="fechaAlta">
                <th class="asuntoNombre" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by fechaAlta" class="header">{{ 'PROCEDIMIENTOS.COL_FECHA' | translate }}</th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'PROCEDIMIENTOS.COL_FECHA' | translate" data-role="meta">
                    {{ formatoFecha(element.fechaAlta) | date:'dd/MM/yyyy HH:mm':'UTC' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef class="header em-th-actions">{{ 'COMMON.ACTIONS' | translate }}</th>
                <td mat-cell *matCellDef="let element" data-role="actions" class="em-td-actions">
                    <div class="em-actions-wrap">
                        <button type="button" class="em-icon-btn" [matTooltip]="'PROCEDIMIENTOS.TOOLTIP_COPY_T' | translate" matTooltipClass="em-tooltip" matTooltipPosition="left" (click)="openCopyDialog(element.id)">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                        <button type="button" class="em-icon-btn" [matTooltip]="'PROCEDIMIENTOS.TOOLTIP_EDIT_T' | translate" matTooltipClass="em-tooltip" matTooltipPosition="left" (click)="editarTramite(element)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button type="button" class="em-icon-btn" [matTooltip]="'PROCEDIMIENTOS.TOOLTIP_EXPORT' | translate" matTooltipClass="em-tooltip" matTooltipPosition="left" (click)="exportarTramite(element)">
                            <mat-icon>download</mat-icon>
                        </button>
                        <button type="button" class="em-icon-btn" [matTooltip]="'PROCEDIMIENTOS.TOOLTIP_SEND' | translate"
                                matTooltipClass="em-tooltip"
                                matTooltipPosition="left"
                                *ngIf="destinosTransfer.length > 0"
                                [matMenuTriggerFor]="menuDestinos">
                            <mat-icon>send</mat-icon>
                        </button>
                        <mat-menu #menuDestinos="matMenu">
                            <button mat-menu-item *ngFor="let destino of destinosTransfer"
                                    (click)="openEnviarEntornoDialog(element, destino)">
                                <mat-icon>cloud_upload</mat-icon>
                                <span>{{ 'PROCEDIMIENTOS.SEND_TO' | translate:{destino: destino} }}</span>
                            </button>
                        </mat-menu>
                        <button type="button" class="em-icon-btn em-icon-btn--danger" [matTooltip]="'PROCEDIMIENTOS.TOOLTIP_DELETE' | translate" matTooltipClass="em-tooltip" matTooltipPosition="left" (click)="openDeleteDialog(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="5" showFirstLastButtons style="padding: 15px;">
        </mat-paginator>

        <div class="load-more-row" *ngIf="paginator?.hasNextPage()">
            <button type="button" class="load-more-btn" (click)="cargarMas()">{{ 'COMMON.LOAD_MORE' | translate }}</button>
        </div>
    </div>

    <button type="button" class="em-btn em-btn--primary m-left" (click)="crearNuevoTramite()">
        <mat-icon>add</mat-icon> {{ 'PROCEDIMIENTOS.CREATE_DYN' | translate }}
    </button>
    <button type="button" class="em-btn m-left"
            [disabled]="importandoTramite"
            (click)="importInput.click()">
        <mat-icon>upload</mat-icon>
        {{ (importandoTramite ? 'PROCEDIMIENTOS.IMPORTING' : 'PROCEDIMIENTOS.IMPORT') | translate }}
    </button>
    <input #importInput type="file" accept=".json,application/json" hidden
           (change)="onImportFileSelected($event)">
</div>

<app-form-builder-tramite
    *ngIf="creandoProc"
    [editingId]="editingProcId"
    (close)="onBuilderClose($event)">
</app-form-builder-tramite>
